import styled from 'styled-components'

export const Container = styled.div`
  overflow-x: auto;
  height: 312px;
`

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: ${props => props.theme.primitives.radius.radius2};

  tbody:before {
    line-height: ${props => props.theme.spacing.sp8};
    content: '-';
    display: block;
    color: transparent;
  }
`
